function getInitials(str) {
  let matches = str.match(/\b(\w)/g);
  return matches ? matches.join('') : 'Default';
}
export function generateAvatar(data) {
  const host = localStorage.getItem('api-host') || process.env.VUE_APP_API_HOST
  let apiBase = `${host}/api/public/${process.env.VUE_APP_API_VERSION}`
  let defaultImage = `${apiBase}/avatar?name=Avatar`;
  let baseUrl = `${apiBase}/avatar?name=`;

  if(!data) return defaultImage;
  if(typeof data === 'string') {
    return baseUrl + getInitials(data);
  }
  if(data.image) return data.image;
  let prop = data.full_name ? 'full_name' : 'given_name';
  if (data[prop]) {
    return baseUrl + data[prop];
  }
  return defaultImage;
}
export default {
  install(Vue) {
    Vue.prototype.$avatar = {
      generate: generateAvatar
    }
  }
}
